export enum CareProductType {
    DBC = 'DBC',
    MKC = 'MKC',
    OVP = 'OVP',
}
